var swiper;
$(function(){
  $(document).keydown(function(event){
    if(event.keyCode == 13) {      
      event.preventDefault();
      console.log("ENTER PRESSED");
      return false;      
    }
  });

  swiper = new Swiper(".swiper", { 
    effect: "cards",           
    slidesPerView: 1,
    allowTouchMove: false,
    breakpoints: {
      //576:{slidesPerView: 1,},
      //768:{slidesPerView: 1,},
    },      
  });

  // ---- HEIGHT HANDLING (added) ----
  function setQuizHeight() {
    var $activeSlide = $('.swiper-slide').eq(swiper.activeIndex);
    // prefer visible content container on that slide
    var $activeContent = $activeSlide.find('.pp_custom_inputs:visible').first();
    if (!$activeContent.length) {
      $activeContent = $activeSlide;
    }
    if ($activeContent.length) {
      var h = $activeContent.outerHeight(true); // include margins
      $('.swiper').css('height', h + 'px');
    }
  }

  swiper.on('slideChangeTransitionEnd', setQuizHeight);
  // initial height
  setQuizHeight();

  // re‑measure height after UI inside a slide changes
  $('.show_motifs, .hide_motifs, .show_login, .show_register, #show_create_btn, #hide_create_btn')
    .on('click', function () {
      setTimeout(setQuizHeight, 0);
    });
  // ---- END HEIGHT HANDLING ----

  $(".form-check-input").change(function(){
    //var inp = trg.parent().parent();
    var checkboxes = $(this).parent().parent().find('.form-check-input');
    var inp = $(this).parent().parent().parent().find(".info_hld")
    console.log(inp.val())
    inp.val("");
    checkboxes.each(function(){
      //console.log($(this).val())
      if($(this).is(":checked")){
        if(inp.val() == ""){
          var curr_v= $(this).val(); 
        }else{
          var curr_v= inp.val()+","+$(this).val(); 
        }
        
        inp.val(curr_v);
      }else{
        
      }
    })
  });
  $(".vthumb_title").each(function(){
    console.log(".vthumb_title")
    let txt = $(this).text();
    const txt_v = txt.split("for");
    $(this).text(txt_v[0]);

  });
  $(".var_opt_thmb").mouseenter(function(){
    $(this).find(".vthumb_txt_hld").css("background","#B59A93");
  });
  $(".var_opt_thmb").mouseleave(function(){
    $(this).find(".vthumb_txt_hld").css("background","#D0BAAE"); 
  });
  $(".var_opt_thmb").click(function(){    console.log($(this).data("vid"));
    $("#select_subscription_size").val($(this).data("vid")).change();
    resetbg();                    
    $(this).find(".vthumb_txt_hld").css("background","#B59A93");
    swiper.slideNext();
  }); 
  $(".sthmb_hld , .lthmb , .ms_thmb").click(function(){
    if($(this).hasClass("tsel")){
      $(this).removeClass("tsel");
      //txtsel
      $(this).find(".sthmb_tit_hld").removeClass("txtsel");
    }else{
      $(this).addClass("tsel");  
      $(this).find(".sthmb_tit_hld").addClass("txtsel");
    }
    
  });
  
  ///Test Function

  //next_btn
  $(".next_btn").click(function(){ 
    console.log("next_btn CLICK");            
    var trg = $(this).data("trg");      
    trg = "."+trg;
    console.log("TRG:",trg);
    var shop_inp ="";
    var flg = false;
    $(trg).each(function(){
      if($(this).hasClass("tsel")){
        console.log("has");
        console.log("TRG TXT new",$(this).find(".t_title").text());
        if(flg){
          shop_inp = shop_inp+ ", " + $(this).find(".t_title").text();  
                  
        }else{
          shop_inp = shop_inp + $(this).find(".t_title").text();          
          flg = true;
        }          
        console.log("SI:",shop_inp);
      }        
    })
    console.log("shop_inp",shop_inp);
    //$(this).parent().children(".info_hld").val(shop_inp);
    $(this).parent().children(".info_hld").attr("value",""+shop_inp+"");
    console.log("X",$(this).parent().children(".info_hld").val());    
    ///IF Second half true
    if($(this).data("trgse")){
      var trgse = $(this).data("trgse");      
      trgse = "."+trgse;
      console.log(trgse);
      var shop_inp2 ="";
      var flg2 = false;
      $(trgse).each(function(){
        if($(this).hasClass("tsel")){
          console.log("has");
          if(flg2){
            shop_inp2 = shop_inp2+ "; " + $(this).find(".t_title2").text();          
          }else{
            shop_inp2 = shop_inp2 + $(this).find(".t_title2").text();          
            flg2 = true;
          }
          
        }
      })
      console.log("shop_inp2:",shop_inp2);
      $(this).parent().children(".info_hld2").val(shop_inp2);        
      
    }
    if(!$(this).data("break")){
      swiper.slideNext(); 
      
    }
    if($(this).data("break")){
      clickCheckout();
    }
      
    console.log("AAAAAAAA:",$(this).parent().children(".info_hld").val());     
  });
  $(".back_btn").click(function(){
    console.log("swiper.activeIndex:",swiper.activeIndex);
    if(swiper.activeIndex == 1){
      $("#reviews_container").removeClass("d-none");
    }
    swiper.slidePrev();
  });
  swiper.on('slideChange', function () {    
    var ai = swiper.activeIndex;
    var len = swiper.slides.length
    len = len -2    
    if( swiper.activeIndex > 0 ){
      //$(".prog_hld").css("display","block");
      //$("#slide_txt").text(ai+"/"+len);        
      var perc = ai/10;        
      perc = perc * 100;
      var p_str = perc.toString();
      p_str = p_str+"%";      
      $("#mid_bar").css("width",p_str)
    }else{
      $("#progress").css("display","none");
    }
  });
  $(".show_motifs").click(function(){
    $(".sep_mot").each(function(){        
      if($(this).hasClass("d-none")){
        $(this).removeClass("d-none");          
      }
    })
    if($(this).siblings(".hide_motifs").hasClass("tsel")){
      $(this).siblings(".hide_motifs").removeClass("tsel");
    }
    motifs_open = true;
  });
  $(".hide_motifs").click(function(){
    $(".sep_mot").each(function(){        
      if(!$(this).hasClass("d-none")){
        $(this).addClass("d-none")          
      }
    })
    $(this).siblings().each(function(){
      $(this).removeClass("tsel");
    })
    motifs_open = false;
  });
  ///ACCOUNT
  $("#create_acc").click(function(){      
    firstName = $("#cr_fname").val();
    lastName = $("#cr_lname").val();
    email = $("#cr_email").val();
    password = $("#cr_pw").val();
    console.log("CREATE",firstName, lastName, email, password);
    if($(this).data("chkout")){
      flag = true;
    }
    createAccount(firstName, lastName, email, password,flag)
  })
  //login_acc
  $("#login_acc").click(function(){     
    
    email = $("#log_email").val();
    password = $("#log_pw").val();    
    var flag = false;  
    if($(this).data("chkout")){
      flag = true;
    }
    loginUser(email, password,flag)
  })
  function createAccount(firstName, lastName, email, password,flag){
    var escapedData = {
        firstName: escape(firstName),
        lastName: escape(lastName),
        email: escape(email),
        password: escape(password).replace(/\+/g, '%2B')
    }
    var data = 'form_type=create_customer&utf8=%E2%9C%93&customer%5Bfirst_name%5D=';
    data += escapedData.firstName;
    data += '&customer%5Blast_name%5D=';
    data += escapedData.lastName;
    data += '&customer%5Bemail%5D=';
    data += escapedData.email;
    data += '&customer%5Bpassword%5D=';
    data += escapedData.password;
    jQuery.post('/account', data)
    .done(function(response){
      var logErrors = jQuery(response).find('.errors').text();
      if (logErrors != '' && logErrors != 'undefined'){
        console.log("ERRORS:",logErrors);        
        $("#cont_err_over").css("display","flex");
        $("#err_form_txt").text(logErrors);
      }
      else{
        if(flag){
          clickCheckout()
        }else{
          morphToLogin();
        }
        
      }
    }).fail(function(){
      $("#err_form_txt").text("An Unknown Error Occured Please Try Again Later");
      $("#cont_err_over").css("display","flex");
    });
    return false;
  }
  function loginUser(email, password,flag){
    var escapedData = {          
        email: escape(email),
        password: escape(password).replace(/\+/g, '%2B')
    }
    var data = 'form_type=customer_login&utf8=%E2%9C%93&customer%5Bemail%5D=';
    data += escapedData.email;
    data += '&customer%5Bpassword%5D=';
    data += escapedData.password;
    jQuery.post('/account/login', data)
    .done(function(response){      
      var logErrors = jQuery(response).find('.errors').text();
      console.log("ERRORS:",logErrors);
      if (logErrors != '' && logErrors != 'undefined'){                
        $("#cont_err_over").css("display","flex");
        $("#err_form_txt").text(logErrors);
      }
      else{
        if(flag){
          clickCheckout()
        }else{
          morphToLogin();
        }
      }
    }).fail(function(){      
      $("#err_form_txt").text("An Unknown Error Occured Please Try Again Later");
      $("#cont_err_over").css("display","flex");
    });
    return false;
  }
  $("#err_ok").click(function(){     
    $("#cont_err_over").css("display","none");
  });
  function morphToLogin(){    
    var top_txt = `<a href="/account">My Account</a>`;
    //$(".account_lnk").attr('href',"/account").text("My Account");    
    var repl = `<a class="account_lnk" href="/account">My Account</a>`
    $("#customer_login_link").replaceWith(repl);
    swiper.slideNext();
  }
  $(".zoom_icon").click(function(){
    console.log("MAG CLICKED");
    document.getElementById("overlay").style.display = "flex";
    console.log($(this).data("pimg"));
    $("#preview_img").attr('src',$(this).data("pimg"))
    ///
    var img = $("#preview_img");
    checkImageLoaded(img);
  })
  function checkImageLoaded(img) {
    if (img[0].complete) {
      console.log("Image loaded");
      img.css("opacity","1");
      $(".close_icon").css("display","block");

    } else {
      console.log("Image still loading");
      setTimeout(function() {
        checkImageLoaded(img);
      }, 100);
    }
  }

  $("#overlay").click(function(){
    console.log("overlay CLICKED");
    document.getElementById("overlay").style.display = "none";    
    $("#preview_img").css("opacity","0");
    $(".close_icon").css("display","none");
    

  })

  //Overlay
  function off() {
    document.getElementById("overlay").style.display = "none";
  }
  $( "#datepicker" ).datepicker({
    changeMonth: true, 
    changeYear: true,      
    yearRange: '1900:+0'
    });    
  
  $(".cal_button").click(function() {
      $("#datepicker").datepicker("show");
  });
  $("#datepicker").on("blur", function() {
    console.log("BLURRRR");
    hidePicker();      
  });
  $("#whatelse").click(function(){
    hidePicker();
  });
  function hidePicker(){
    var ele = $("#datepicker"); 
    if (!ele.hasClass("hasDatepicker") && !ele.hasClass("ui-datepicker") && !ele.hasClass("ui-icon") && !$(ele).parent().parents(".ui-datepicker").length){
      $(".hasDatepicker").datepicker("hide");  
    }
  }
  

  $(".ppf_x_hld, .pf_btn").click(function(){
    console.log("CLICKEDDDD")
    $("#form-overlay").css("display","none");
  });
  $(".sthmb_hld").hover(function(){
    $(this).children(".sthmb_tit_hld").toggleClass("hover_bg");
    console.log("HOVERING")
  });
  function resetbg(){
    $(".vthumb_txt_hld").each(function(){
      $(this).css("background","#D0BAAE")
    })
  }
})